// Tiny haptic tap for touch interactions. Android Chrome supports
// navigator.vibrate; iOS silently ignores it — that's fine, no fallback needed.
export const haptic = (ms = 10): void => {
  try {
    navigator.vibrate?.(ms);
  } catch {
    // older browsers without the API — nothing to do
  }
};
